/**
 * Class that provides functionality for the Read More Gutenberg Block
 */
export default class ReadMore {
    constructor(element, height){
        this.element = element;
        this.height = height;
        this.mobileHeight = height * 2;
        this.isOpen = false;
        this.readMoreButton = element.querySelector('.read-more-button');

        this.addEventListeners();
        this.initialize();
    }

    /**
     * Adds necessary event listeners for the block
     */
    addEventListeners(){
        this.readMoreButton.addEventListener('click', () => {
            this.processReadMore();
        });

        window.addEventListener('resize', () => {
            this.processWindowResize();
        })
    }

    /**
     * Runs upon startup & sets block to base state
     */
    initialize(){
        let height;
        if(this.isMobile()){
            height = this.mobileHeight;
        } else {
            height = this.height;
        }

        if(this.element.offsetHeight > height){
            this.showLess();
        } else {
            this.removeSeeMoreButton();
        }
    }

    /**
     * Removes the See More button from the page
     */
    removeSeeMoreButton(){
        this.readMoreButton.style.display = 'none';
    }

    /**
     * Scroll to top of main element
     */
    scrollToTop(){
        // Scroll to 75px above the top of the element
        window.scrollTo({
            top: this.element.getBoundingClientRect().top + window.pageYOffset - 75, 
            behavior: 'smooth',
        });
    }

    /**
     * Is the window currently mobile sized?
     * @returns {bool}
     */
    isMobile(){
        return window.innerWidth < 768;
    }

    /**
     * Sets the container to this height in px
     * @param {int} height 
     */
    setToHeight(height){
        this.element.style.maxHeight = height + 'px';
    }

    /**
     * Collapses the block to the shortened height
     */
    showLess(){
        this.element.classList.add('collapsed');
        this.readMoreButton.innerHTML = 'Read More';

        if(this.isMobile()){
            this.setToHeight(this.mobileHeight);
        } else {
            this.setToHeight(this.height);
        }
    }

    /**
     * Expands the block to full height
     */
    readMore(){
        this.element.classList.remove('collapsed');
        this.element.style.maxHeight = '10000px';
        this.readMoreButton.innerHTML = 'Show Less';
    }

    /**
     * This runs when the button is clicked. Toggles the state of the block
     */
    processReadMore(){
        if(this.isOpen){
            this.isOpen = false;
            this.showLess();
            this.scrollToTop();
        } else {
            this.isOpen = true;
            this.readMore();
        }
    }

    /**
     * Runs when the window is resized.
     */
    processWindowResize(){
        if(!this.isOpen){
            if(this.isMobile()){
                this.setToHeight(this.mobileHeight);
            } else {
                this.setToHeight(this.height);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./scripts/class/ReadMore.js